var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DialogLoading',{attrs:{"message":_vm.loadingMessage,"active":_vm.loading}}),_vm._v(" "),(_vm.showClientsGraphic)?_c('div',[_c('apexchart',{attrs:{"type":"line","height":"300","options":_vm.clientsRegisterOptions,"series":_vm.clientsRegisterData}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bdcac1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/RecordsClients.vue
// module id = 512
// module chunks = 5